module.exports = __webpack_public_path__ + "static/dmon-012-8559243cbe3c19dff681c5f7263f3cef.jpg";